export default __webpack_public_path__ + "static/media/Blue Peafowl.2daadc1d.jpg";